//全局变量
var API_URL = process.env.ADMIN_API;
var IMG_URL = process.env.IMAGE_BASE_URL;
var dict = {
  //全局字典
  ADMIN_URL: API_URL, //API具体路径
  IMG_URL: IMG_URL
};
export {
  dict
};



// WEBPACK FOOTER //
// ./src/utils/base.js